import { render } from "./user_details.vue?vue&type=template&id=474a91ea&scoped=true"
import script from "./user_details.vue?vue&type=script&lang=js"
export * from "./user_details.vue?vue&type=script&lang=js"

import "./user_details.vue?vue&type=style&index=0&id=474a91ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-474a91ea"]])

export default __exports__